import React, { useEffect, useState } from "react";
import styled from "styled-components/macro";

import { getPodcast } from "../api/api";
import Breadcrumbs from "../components/Breadcrumbs";
import PodcastSettings from "../components/PodcastSettings";
import Snackbar from "../components/SaveSuccess";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";

export default (props) => {
  const [podcast, setPodcast] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);

  let { match } = props || {};
  let { params } = match || {};
  let { podcastId } = params || {};

  useEffect(() => {
    let doGetPodcast = () => {
      getPodcast(podcastId)
        .then((response) => response.json())
        .then((data) => {
          setPodcast(data);
        });
    };

    doGetPodcast();
  }, [podcastId]);



  return (
    <PodcastEdit>
      <Breadcrumbs
        crumbs={[
          { path: "/podcasts", text: "Podcasts" },
          { path: `/podcasts/${podcastId}`, text: `Podcast` },
        ]}
        currentPath={`Edit Podcast`}
      />
      <h1>Edit Podcast: {podcast.title}</h1>

        {podcast.podigee_podcast_id &&
            <div>
                <h2>Bookmarklet for Podigee Podcasts</h2>
                <div>
                    <Card className={'card'} key={`card--bookmarklet`}>
                        <CardContent>
                            <BookmarkletDescription>Bookmarklet for Podigee-Podcasts. <p>Drag&Drop to your bookmarks or Right-Click -> Copy Link Adress and add manually to bookmarks</p></BookmarkletDescription>
                                <div>
                                    {/*<Bookmarklet href='javascript: (function() { try{ var mediafile = encodeURIComponent(document.querySelector("a[download][href*=\"main.podigee-cdn.net\"],a[download][href*=\"audio.podigee-cdn.net\"]").getAttribute("href")); var title = encodeURIComponent(document.querySelector("input[ng-model=\"episode.title\"]").value); var referrer = encodeURIComponent(window.location.pathname); } catch(e){ console.log(e); } if(!mediafile) { return alert("Es wurde keine Mediendatei gefunden"); } if(!window.location.href.includes("podigee")) { return alert("Dieses Bookmarklet funktioniert nur für Podigee Podcasts"); } window.open("https://dashboard.b.audioadserver.com/entry/?mediafile=" + mediafile + "&referrer=" + referrer + "&title=" + title); })();'>ASAP Import Podigee</Bookmarklet>*/}
                                    <Bookmarklet href='javascript: (() => {    const episode_data = async () => {        const episode_id = document.querySelector("span[ng-init*=episode_id]").getAttribute("ng-init").replace("episode_id=", "");        const episode_data = await fetch(`https://app.podigee.com/api/v1/episodes/${episode_id}`).then(response => response.json());        const { podcast_id, title } = episode_data;        const { media_clips } = await fetch(`https://app.podigee.com/api/episodes/${episode_id}/media_clips`).then(response => response.json());        const { enclosure_url } = media_clips.filter(item => item.file_format === "mp3").pop();        const marker = await fetch(`https://app.podigee.com/api/podigee/content_markers?podcast_id=${podcast_id}`).then(response => response.json());        const adbreaks = [];        for(let i = 0; i < marker.length; i++) {            let m = marker[i];            let url = `https://app.podigee.com/api/podigee/content_marker_positions?content_marker_id=${m.id}&episode_id=${episode_id}`;            let positions = await fetch(url).then(response => response.json());            positions.forEach(item => {                adbreaks.push({                    title: m.title,                    type: m.kind,                    position_in_ms: item.position                })            })        }        console.log("Title: " + title);        console.log("Enclosure: " + enclosure_url);        adbreaks.forEach(item => {            console.log(`Adbreak: ${item.type} (${item.title}) at ${item.position_in_ms}ms`);        });        const referrer = encodeURIComponent(window.location.pathname);        const params = new URLSearchParams();        params.append("mediafile", enclosure_url);        params.append("referrer", referrer);        params.append("title", title);        params.append("podcast_id", podcast_id);        params.append("adbreaks", JSON.stringify(adbreaks));        if(!enclosure_url) {            return alert("Es wurde keine Mediendatei gefunden");        }        if(!window.location.href.includes("podigee")) {            return alert("Dieses Bookmarklet funktioniert nur für Podigee Podcasts");        }        window.open(`https://dashboard.b.audioadserver.com/entry/?${params.toString()}`);    };    episode_data();})()'>ASAP Import Podigee</Bookmarklet>
                                </div>
                        </CardContent>
                    </Card>
                </div>
            </div>}

      <Snackbar
        openSnackbar={openSnackbar}
        setOpenSnackbar={setOpenSnackbar}
      ></Snackbar>

      <PodcastSettings
        podcast={podcast}
        setPodcast={setPodcast}
        podcastId={podcastId}
        setOpenSnackbar={setOpenSnackbar}
      />
    </PodcastEdit>
  );
};

const PodcastEdit = styled.div``;

const Bookmarklet = styled.a`
  padding: 6px 16px;
  font-size: 0.875rem;
  min-width: 64px;
  box-sizing: border-box;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 500;
  line-height: 1.75;
  border-radius: 4px;
  letter-spacing: 0.02857em;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.87);
  background-color: #8cc63f;
  box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
`;

const BookmarkletDescription = styled.div`
  padding: 0 0 12px 0;
`
